import { useEffect, useRef, useState } from "react";
import "./Calendar.css"

type SelectionMode = "select" | "deselect" | "drag"

interface PropsClickAndDragSelector {
    data: { id: string, label: string, data: object }[]
}


export function TestDragger2(
    { data }: PropsClickAndDragSelector
) {

    //This is the things we want to select from (will be substituted by days later)
    const numbers = data // [1, 2, 3, 4, 5, 6, 7, 8, 9, 10]


    let draggingTimer = useRef<any>(null)
    const HOLD_THRESHOLD = 150;
    const handleMouseDown = (initialElem: any) => {
        draggingTimer.current = setTimeout(() => {
            handleStartDrag()
            setSelectedSet((prev) => {
                //Dragging only will add elements
                const newSet = new Set(prev);
                newSet.add(initialElem)
                return newSet;
            })
            console.log("Started dragging or long hold");
        }, HOLD_THRESHOLD);
    };


    const mode = useRef<SelectionMode>("select")

    const dragging = useRef(false)


    const [selectMode, setSelectMode] = useState<SelectionMode>("select");


    const [selectedSet, setSelectedSet] = useState<Set<any>>(new Set())



    const [draggingState, setDraggingState] = useState(false)

    const handleStartDrag = () => {
        dragging.current = true
        setDraggingState(true)
    }
    const handleEndDrag = () => {
        clearTimeout(draggingTimer.current as any)
        draggingTimer.current = null;
        dragging.current = false;
        setDraggingState(false);
    }


    useEffect(() => {
        window.addEventListener('mouseup', handleEndDrag);

        console.log("removed timeout because i went to the body")
        return () => window.removeEventListener('mouseup', handleEndDrag);
    }, []);

    const isSelected = (element: any, selectedSet: Set<any>) => {

        return (selectedSet.has(element))


    }

    const generateDayElements = () => {
        return numbers.map(({ id, label, data }, idx) => {

            const d = id

            return <span

                key={idx}

                onClick={() => {
                    if (!dragging.current) {
                        setSelectedSet((prev) => {

                            const newSet = new Set(prev);
                            if (newSet.has(d)) {
                                newSet.delete(d);
                            } else {
                                newSet.add(d);
                            }
                            return newSet;
                        })
                    }
                }}


                onMouseDown={() => {
                    if (!dragging.current) {
                        handleMouseDown(d)

                    }
                }}

                onMouseEnter={() => {
                    if (dragging.current === true) {
                        setSelectedSet((prev) => {
                            const newSet = new Set(prev);

                            newSet.add(d);

                            return newSet;
                        })
                    }

                }}

                onMouseUp={() => {
                    handleEndDrag()
                }}



                className={"day " + ((isSelected(d, selectedSet)) ? "selected" : "nope")}

            >


                {label}

            </span>;
        });
    };

    return (
        <>
            {/* <h1> Slot selector 2</h1> */}
           {false && 
           <>
           <h1>  {draggingState ? "Dragging..." : "Idle"}</h1>
            <h2> {JSON.stringify(Array.from(selectedSet))}</h2>
    </>
    }
            <div
                className="slots-container"
                style={{
                    display: "flex", flexDirection: "column", gap: "1em", overflowY: "auto",
                    alignItems: "center",
                    padding: "1em",
                    borderRadius: "20px",
                    maxHeight: "30vh",

                    maxWidth: "180px"
                }}>
                {generateDayElements()}

            </div>
        </>
    )
}


export function generateThirtyMinuteSlots() {
    const slots = [];
    const start = new Date();
    start.setHours(0, 0, 0, 0); // Midnight

    const MS_PER_HALF_HOUR = 30 * 60 * 1000;
    const totalSlots = 24 * 2; // 48 half-hour slots

    for (let i = 0; i < totalSlots; i++) {
        const from = new Date(start.getTime() + i * MS_PER_HALF_HOUR);
        const to = new Date(from.getTime() + MS_PER_HALF_HOUR);

        const label = `${formatTime(from)} - ${formatTime(to)}`;
        const id = `${pad(from.getHours())}${pad(from.getMinutes())}`;

        slots.push({
            id,
            label,
            data: { from, to }
        });
    }

    return slots;
}

function formatTime(date: Date) {
    const hours = date.getHours();
    const minutes = date.getMinutes();
    const paddedMinutes = pad(minutes);
    return `${hours}:${paddedMinutes}`;
}

function pad(number: number) {
    return number.toString().padStart(2, '0');
}



export function generateDateRange(start: Date, end: Date): Date[] {
  const dates: Date[] = [];
  const current = new Date(start);

  while (current <= end) {
    dates.push(new Date(current));
    current.setDate(current.getDate() + 1);
  }

  return dates;
}

export function isSameDay(date1: Date, date2: Date): boolean {
  return (
    date1.getFullYear() === date2.getFullYear() &&
    date1.getMonth() === date2.getMonth() &&
    date1.getDate() === date2.getDate()
  );
}